import { shouldLoadAnalytics } from "./utils/chinaDetection";

export const pushDL = (event, params = {}) => {
  // Don't push analytics if user is in China
  if (!shouldLoadAnalytics()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};
